import { getCurrentInstance } from '@vue/composition-api';

export const useBuefy = () => {
    const vm = getCurrentInstance();
    if (!vm) {
        throw new Error('useBuefy must be called in setup');
    }
    return vm.proxy.$buefy;
};
